import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { $GET, SERVER_URL } from "../../../api";
import { addServices } from "../../../store/slices/services.slice";
import Router from "../../../const/router";
import "./index.scss";

const Services = () => {
  const services = useSelector((state) => state.services.data);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   const fillServices = async () => {
  //     try {
  //       const { data } = await $GET(Router.SERVICES);
  //       dispatch(addServices(data));
  //     } catch (err) {
  //       throw new Error(err.message);
  //     }
  //   };
  //   fillServices();
  // }, []);

  return (
    <section className="services">
      <div className="section-wrapper">
        <h1 className="section-mention">Services</h1>
        <hr className="section-hr" />
        <h1 className="services-title">What actually I love to do</h1>
        <div className="services-content">
          {services ? (
            services.map((item) => {
              const { _id, name, description, image_url } = item;
              // const imageUrl = `${SERVER_URL}${Router.SERVICES_UPLOAD}/${image_url}`;
              return (
                <div key={_id} className="services-content-item">
                  <div className="row">
                    <img src={image_url} alt="service" />
                    <h1>{name}</h1>
                  </div>
                  <p>{description}</p>
                </div>
              );
            })
          ) : (
            <p>No Service</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Services;
